import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountEmbeddableSearchesIntegrate implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountEmbeddableSearchesIntegrateContainer";
    }
    render(){
        // console.log("integrate embeddable searches");
    }
}